import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';

class ReportsViewRoute extends Route {
  /**
   * Register services
   */
  @service('commands/user-commands') userCommandService;
  @service session;

  /**
   * @inheritDoc
   */
  model() {
    const currentUser = this.session.currentUser;
    const companyId = currentUser.isBuyer ? currentUser.company.id : null;

    if (!currentUser.canViewReportsData) return;

    return this.userCommandService.getAnalyticsSummary(currentUser.id, companyId);
  }
}

export default ReportsViewRoute;
